module.exports = __webpack_public_path__ + "static/img/logo_mob.d91c6f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_mob.png
// module id = Ef89
// module chunks = 1